import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'
import { useCallback, useEffect, useState } from 'react'
import { Animated, Dimensions, Easing } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'

const { height } = Dimensions.get('window')
const initialValue = -height / 1.5
export const PaymentFlashAnimation = ({ callback }: any) => {
  const [rupeeIcon] = useState<any>(new Animated.Value(initialValue))
  const [rippleAnimation] = useState<any>(new Animated.Value(0))

  const startRippleAnimation = useCallback(() => {
    Animated.timing(rippleAnimation, {
      toValue: 1,
      duration: 500,
      delay: 600,
      useNativeDriver: true,
      easing: Easing.linear,
    }).start(({ finished }) => {
      if (finished) {
        callback?.()
      }
    })
  }, [rippleAnimation, callback])

  const fallRupeeIcon = useCallback(() => {
    Animated.timing(rupeeIcon, {
      toValue: 1,
      duration: 300,
      delay: 300,
      easing: Easing.ease,
      useNativeDriver: true,
    }).start()
  }, [rupeeIcon])

  useEffect(() => {
    fallRupeeIcon()
    startRippleAnimation()
  }, [fallRupeeIcon, startRippleAnimation])

  return (
    <Box alignItems={'center'} justifyContent="center">
      <Animated.View
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          transform: [{ scale: rippleAnimation }],
        }}>
        <Box {...style.ripple1} bg={'#F7AB20' as ColorOptions} zIndex={8} position={'absolute'} />
        <Box {...style.ripple2} bg={'#F7AB20' as ColorOptions} zIndex={8} position={'absolute'} />
        <Box {...style.ripple3} bg={'#F7AB20' as ColorOptions} zIndex={8} position={'absolute'} />
      </Animated.View>
      <Animated.View style={{ transform: [{ translateY: rupeeIcon }], position: 'absolute' }}>
        <SvgImage imageName={'StatusRupeeIcon'} />
      </Animated.View>
    </Box>
  )
}

const style = {
  ripple1: {
    opacity: 0.1,
    width: 140,
    height: 140,
    borderRadius: 140,
    position: 'absolute',
  } as BoxProps,
  ripple2: {
    opacity: 0.1,
    width: 200,
    height: 200,
    borderRadius: 200,
    position: 'absolute',
  } as BoxProps,
  ripple3: {
    opacity: 0.1,
    width: 250,
    height: 250,
    borderRadius: 240,
    position: 'absolute',
  } as BoxProps,
}
